export default "__VITE_ASSET__CglkiQTT__"